import P from "prop-types";
import * as S from "../styles";

import { HorizontalZoomBarChart } from "../../Echarts/HorizontalZoomBarChart";

export function HorizontalZoomBarChartCard({
  dados,
  title,
  style,
  grid = false,
}) {
  return (
    <S.Container grid={grid}>
      <p>{title}</p>
      <HorizontalZoomBarChart grid={grid} style={style} dados={dados} />
    </S.Container>
  );
}

HorizontalZoomBarChartCard.propTypes = {
  title: P.string.isRequired,
  grid: P.bool,
  style: P.object.isRequired,
  dados: P.arrayOf(
    P.shape({ name: P.string.isRequired, value: P.number.isRequired })
  ).isRequired,
};
